import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Separator,
  Button,
  H4,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import classnames from 'classnames';
import issueI18n from '@utils/lessonIssueI18n';
import type { ResolvedIssueModalProps } from './resolved-issue-modal.types';

export const ResolvedIssueModal = ({
  peerProfile,
  peerName,
  lessonTime,
  lessonDate,
  consumedTickets,
  consumedNoExpirationTickets,
  issueType,
  reasonTitle,
  actionTitle,
  returnedTickets,
  returnedNoExpirationTickets,
  isLoading,
  onClose,
}: ResolvedIssueModalProps) => {
  const { t } = useTranslation('common');
  const wrapperClass = classnames('max-w-xl mx-auto', { loading: isLoading });

  return (
    <div className={wrapperClass}>
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('modals.issue.resolved.title')}</CardTitle>
          <button type="button" className="modal-close" onClick={onClose}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <div className="">
            <div className="issue-wrapper">
              <div className="mb-4">
                <H4 className="mb-4">{t('modals.issue.aboutLesson')}</H4>
                <div className="mb-8">
                  <b>{peerProfile}: </b>
                  {peerName}
                </div>
                <div className="mb-8">
                  <b>{t('general.time')}: </b>
                  {lessonTime}
                </div>
                <div className="mb-8">
                  <b>{t('general.date')}: </b>
                  {lessonDate}
                </div>
                <div className="mb-8">
                  <b>{t('general.consumedTickets')}:</b> {consumedTickets}
                </div>
                <div className="mb-4">
                  <b>{t('general.consumedNoExpirationTickets')}:</b>{' '}
                  {consumedNoExpirationTickets}
                </div>
              </div>
              <Separator className="my-4" />
              <H4 className="mb-4">{t('modals.issue.aboutIssue')}</H4>
              <div className="mb-4">
                <b>{t('issue.issueType.title')}:</b>
              </div>
              <div className="mb-4">{issueI18n.type(t, issueType)}</div>
              <div className="mb-4">
                <b>{t('issue.issueReason.titleLong')}:</b>
              </div>
              <div className="mb-4">{issueI18n.reason(t, reasonTitle)}</div>
              <div className="mb-4">
                <b>{t('issue.resolveAction.resolvedWith')}:</b>
              </div>
              <div className="mb-4">{issueI18n.action(t, actionTitle)}</div>
              <div className="mb-8">
                <b>{t('general.returnedTickets')}:</b> {returnedTickets}
              </div>
              <div className="mb-4">
                <b>{t('general.returnedNoExpirationTickets')}:</b>{' '}
                {returnedNoExpirationTickets}
              </div>
            </div>
          </div>
          <Separator className="my-4" />
          <div className="text-right">
            <Button variant="outline" onClick={onClose}>
              {t('links.close')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
